import React, { useCallback } from 'react';
import confetti from 'canvas-confetti';
import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';

export const ConfettiButton = ({ 
  children, 
  onClick, 
  className = '',
  confettiColors = ['#2F80FF', '#2DD4BF', '#F59E0B', '#22C55E'],
  ...props 
}) => {
  const handleClick = useCallback((e) => {
    // Get button position for confetti origin
    const rect = e.currentTarget.getBoundingClientRect();
    const x = (rect.left + rect.width / 2) / window.innerWidth;
    const y = (rect.top + rect.height / 2) / window.innerHeight;

    // Fire confetti
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { x, y },
      colors: confettiColors,
      ticks: 200,
      gravity: 1.2,
      scalar: 1.2,
      shapes: ['circle', 'square'],
      disableForReducedMotion: true
    });

    // Also fire some from the sides
    setTimeout(() => {
      confetti({
        particleCount: 50,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 0.7 },
        colors: confettiColors
      });
      confetti({
        particleCount: 50,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 0.7 },
        colors: confettiColors
      });
    }, 150);

    // Call original onClick
    if (onClick) onClick(e);
  }, [onClick, confettiColors]);

  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      <Button
        onClick={handleClick}
        className={className}
        {...props}
      >
        {children}
      </Button>
    </motion.div>
  );
};

// Celebration burst (can be triggered programmatically)
export const triggerCelebration = () => {
  const duration = 3 * 1000;
  const animationEnd = Date.now() + duration;
  const colors = ['#2F80FF', '#2DD4BF', '#F59E0B', '#22C55E'];

  const randomInRange = (min, max) => Math.random() * (max - min) + min;

  (function frame() {
    confetti({
      particleCount: 3,
      angle: 60,
      spread: 55,
      origin: { x: 0, y: 0.8 },
      colors: colors
    });
    confetti({
      particleCount: 3,
      angle: 120,
      spread: 55,
      origin: { x: 1, y: 0.8 },
      colors: colors
    });

    if (Date.now() < animationEnd) {
      requestAnimationFrame(frame);
    }
  }());
};

export default ConfettiButton;
